import { ensureJobCorn } from '@eigtech/restoration-util'
import { PhotoReportStatus as BasePhotoReportStatus } from '@eigtech/ui-shared-documator-web'
import { createFileRoute } from '@tanstack/react-router'
import { withRequiredPermissions } from '../../../../../lib/permissions'

export const Route = createFileRoute('/_auth/jobs/$jobId/_layout/photo-report_/status')({
  component: () => <Component />,
})

function PhotoReportStatus() {
  const { jobId } = Route.useParams()

  return <BasePhotoReportStatus entityId={ensureJobCorn(jobId)} />
}

const Component = withRequiredPermissions(PhotoReportStatus, {
  requiredPermissions: [
    { action: 'read', subject: 'job' },
    { action: 'read', subject: 'document' },
  ],
})
